module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "echarts"
  }, [_c('IEcharts', {
    attrs: {
      "option": _vm.option,
      "loading": _vm.loading
    },
    on: {
      "ready": _vm.onReady,
      "click": _vm.onClick
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bc325512"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/demo/echarts.vue
// module id = 900
// module chunks = 0